import { Box } from '@mui/material'

import {
  FlexRowBetweenBox,
  SubheaderText,
  Text,
} from '@/components/IncomeCard/TrustedSources/styles'
import type { KonfirOutcome as KonfirOutcomeValue } from '@/types/Activity'
import { mapReferenceOutcomeStatus } from '@/utils/referenceOutcomeStatus'

interface Props {
  outcome: KonfirOutcomeValue
}

const KonfirOutcome: React.FC<Props> = ({ outcome }) => (
  <FlexRowBetweenBox sx={{ px: '4px' }}>
    <Box>
      <SubheaderText variant="subtitle2">Outcome Status</SubheaderText>
      <Text variant="body2">{mapReferenceOutcomeStatus(outcome.status)}</Text>
    </Box>
  </FlexRowBetweenBox>
)

export default KonfirOutcome
